/* RESPONSIBLE TEAM: team-proactive-support */
import ComponentConfiguration from '../../component-configuration';

export default ComponentConfiguration.extend({
  init(inputs) {
    inputs.component = 'content-editor/view-mode/checklist/step-analysis';
    this._super(...arguments);
  },
});
